/**
 * Copia `text` al portapapeles con la Clipboard API cuando está disponible;
 * no lanza si no lo está o si el permiso se rechaza — en ambos casos el
 * texto ya queda visible/seleccionable en el DOM de quien llama. Compartido
 * por el chip de correlación del `Toast` (`PortalPrimitives.tsx`) y
 * `CopyTraceIdButton` (`HttpRequestLogScreen.tsx`) — mismo patrón de
 * "copiar identificador" (jscpd, revisión de duplicación 2026-09-23).
 */
export function copyToClipboard(
  text: string,
  onDone: (copied: boolean) => void,
): void {
  const clipboard = navigator.clipboard;
  if (!clipboard?.writeText) return;
  clipboard.writeText(text).then(
    () => onDone(true),
    () => onDone(false),
  );
}
